/**
 * Axios Configuration - SIMPLIFIED
 */

import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://a2amyslpai-server.appsokay.net/api/v1',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - just return data
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Log error but DON'T redirect - let components handle it
    console.error('[API Error]', error.response?.status, error.config?.url);
    return Promise.reject(error);
  }
);

export default axiosInstance;
